import { Injectable } from '@angular/core';
import { CompanyDetailsInterface, CompanyFeatureFlagsInterface, Integration } from './interfaces/company-details.interface';
import { BreachWarningStatus } from './enums/companies-status.enum';
import { SecurityAddOnStatusEnum, SecurityAddOnStatusMapping } from '../securityaddons/enums/security-add-on-status.enum';

export class CompanyDataModel {
    static noBreachWarranty: Readonly<Integration> = {
        id: '',
        type: 'breach_warranty',
        warranty_type: null,
        accepted: false,
        gravityzone_id: '',
        start_date: '',
        end_date: '',
        acknowledged: undefined,
    };

    constructor() {}

    static getBreachWarranty(company: CompanyDetailsInterface): Integration {
        const breachWarranty = this.findBreachWarranty(company);

        if (!breachWarranty) {
            return this.noBreachWarranty;
        }

        return breachWarranty;
    }

    /**
     * Returns the breach warranty integration from the company details.
     * @param company The company details object.
     * @returns The breach warranty integration if it exists, otherwise undefined.
     */
    static findBreachWarranty(company: CompanyDetailsInterface): Integration | undefined {
        if (!company || !company.integrations) {
            return undefined;
        }

        const breachWarranty = company.integrations.find((x) => x.type === 'breach_warranty');
        return breachWarranty;
    }

    static getBreachWarrantyType(company: CompanyDetailsInterface): string {
        const breachWarranty = this.getBreachWarranty(company);
        switch (breachWarranty?.warranty_type) {
            case BreachWarningStatus.Standard:
                return $localize`MDR Breach Warranty`;
            case BreachWarningStatus.Plus:
                return $localize`MDR Breach Warranty PLUS`;
            default:
                return $localize`Not available`;
        }
    }

    static getBreachWarrantyStatus(company: CompanyDetailsInterface) {
        const breachWarranty = CompanyDataModel.findBreachWarranty(company);
        var status = SecurityAddOnStatusEnum.Not_available;

        if (breachWarranty) {
            switch (breachWarranty.warranty_type) {
                case BreachWarningStatus.Standard:
                case BreachWarningStatus.Plus: {
                    var isActive = new Date(breachWarranty.end_date) >= new Date();
                    status = isActive ? SecurityAddOnStatusEnum.Active : SecurityAddOnStatusEnum.Expired;
                    break;
                }

                default:
                    status = SecurityAddOnStatusEnum.Declined;
            }
        }

        return SecurityAddOnStatusMapping[status].name;
    }

    static isCompanySelectorVisible(companyDetails: CompanyFeatureFlagsInterface): boolean {
        return companyDetails?.configuration?.features?.enableCompanySelector === true;
    }
}
